import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, ref, watch } from "vue";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/userStore";
import { CACHED_QNA_IMAGE_KEY_PREFIX, VocStatusCode } from "@/types";
import { useFileStore } from "@/stores/fileStore";
import DOMPurify from "dompurify";
import { useValidateUrlLink } from "@/composables/shared/useValidateUrlLink";
import { IVocDetail } from "@/domain/entities/bbs";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "VocDetail",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  vocDetail: {
    type: Object as PropType<IVocDetail>,
    required: true,
  },
},
  emits: ["onClickEditBtn", "onClickDeleteBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const props = __props;

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const fileStore = useFileStore();

const userInfo = computed(() => userStore.userInfo);
const isMyPost = computed(
  () => userInfo.value?.uid === props.vocDetail.writerUid
);

const vocStatusCodeMap: Record<string, string> = {
  [VocStatusCode.SUBMIT]: "submit",
  [VocStatusCode.ASSIGN]: "assign",
  [VocStatusCode.ACTIVE]: "active",
  [VocStatusCode.PAUSED]: "paused",
  [VocStatusCode.CLOSED]: "closed",
  [VocStatusCode.ANSWER]: "answer",
  [VocStatusCode.DISCAR]: "discard",
};

const imageUrls = ref<any[]>([]);
const noImage = require("@/assets/images/no-image.png");
const getImageUrl = async (fileUid: string, index: number) => {
  const urlResult = await fileStore.getFileUrl(
    fileUid,
    true,
    CACHED_QNA_IMAGE_KEY_PREFIX
  );
  imageUrls.value[index] = urlResult.data ?? noImage;
};

const scrollContainerRef = ref<HTMLElement>();

/** url 링크 유효성 검사 */
const { validateUrlLink } = useValidateUrlLink();

const emitOnClickEditBtn = () => {
  emit("onClickEditBtn");
};

const emitOnClickDeleteBtn = () => {
  emit("onClickDeleteBtn");
};

const goToQnaList = () => {
  route.meta.willGoBack = true;
  router.back();
};

watch(
  () => props.vocDetail,
  (vocDetail) => {
    if (!vocDetail?.files?.length) return;

    imageUrls.value = Array(vocDetail.files.length).fill(noImage);
    vocDetail.files.forEach((file, index) => {
      getImageUrl(file?.fileUid ?? "", index);
    });
  }
);

const __returned__ = { emit, props, route, router, userStore, fileStore, userInfo, isMyPost, vocStatusCodeMap, imageUrls, noImage, getImageUrl, scrollContainerRef, validateUrlLink, emitOnClickEditBtn, emitOnClickDeleteBtn, goToQnaList, FooterButton, get VocStatusCode() { return VocStatusCode }, get DOMPurify() { return DOMPurify }, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})